export const REFRESH_NFT_OF_THE_WEEK_UPDATE_TOKEN = 'REFRESH_NFT_OF_THE_WEEK_UPDATE_TOKEN';
export const RESET_NFT_OF_THE_WEEK_DATA = 'RESET_NFT_OF_THE_WEEK_DATA';
export const FETCH_NFT_OF_THE_WEEK = 'FETCH_NFT_OF_THE_WEEK';
export const FETCH_NFT_OF_THE_WEEK_ASSET = 'FETCH_NFT_OF_THE_WEEK_ASSET';
